import { useQuery } from "@tanstack/react-query";
import { address as toAddress } from "@solana/kit";
import { solanaService } from "../services/solana";
import { useBrowserWalletStore } from "@/features/wallet";
import { useAuthStore } from "@/store/auth-store";

/**
 * Hook to fetch SOL balance for connected wallet.
 * Uses React Query for caching and automatic refetching.
 */
export function useSolanaBalance() {
  const publicKey = useBrowserWalletStore((state) => state.publicKey);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const query = useQuery({
    queryKey: ["solana-balance", publicKey],
    queryFn: async () => {
      if (!publicKey) {
        throw new Error("No wallet connected");
      }
      return solanaService.getBalance(toAddress(publicKey));
    },
    enabled: publicKey !== null && isAuthenticated,
    staleTime: 60_000,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
  });

  return {
    balance: query.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
}
